import { render, staticRenderFns } from "./keyword-details.component.vue?vue&type=template&id=4bfc5a2c&scoped=true"
import script from "./keyword-details.component.vue?vue&type=script&lang=ts"
export * from "./keyword-details.component.vue?vue&type=script&lang=ts"
import style0 from "./keyword-details.component.vue?vue&type=style&index=0&id=4bfc5a2c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bfc5a2c",
  null
  
)

export default component.exports